import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {Controller, useForm} from 'react-hook-form';
import {getAccountTypes, getInventoryTypes} from "../common/api/InventoryApi";
import MDButton from "../../components/MDButton";
import {FormControlLabel, NativeSelect, TextareaAutosize} from "@mui/material";
import {CONSTANTS} from "../common/constants";
import MDInput from "../../components/MDInput";
import Checkbox from "@mui/material/Checkbox";

export default function ManageInventoryMembershipModal(props) {

  const [context, setContext] = useContext(AppContext);
  const [inventory, setInventory] = useState(props.inventory);
  const [isInventoryEvent, setIsInventoryEvent] = useState(props.isInventoryEvent);

  const [accountTypes, setAccountTypes] = useState();
  const [inventoryEventTypes, setInventoryEventTypes] = useState();

  const [inventoryImage, setInventoryImage] = useState(null);
  const [inventoryImageName, setInventoryImageName] = useState(null);
  const [inventoryImageType, setInventoryImageType] = useState(null);
  const statuses = [...CONSTANTS.STATUSES];

  const [preview, setPreview] = useState(null);
  const [inventoryTypes, setInventoryTypes] = useState();

  const [formInvalid, setFormInvalid] = useState(false);
  const [typesReady, setTypesReady] = useState(false);

  const [accountType, setAccountType] = useState(props?.inventory?.accountType);

  const [lockedAccount, setLockedAccount] = useState(false);
  const [minimumMembership, setMinimumMembership] = useState(props?.inventory?.minimumMembership || false);
  const [minMembershipMonths, setMinMembershipMonths] = useState(props?.inventory?.minMembershipMonths || 0);

  const [minimumCancellation, setMinimumCancellation] = useState(props?.inventory?.minimumMembership || false);
  const [minimumCancellationDays, setMinimumCancellationDays] = useState(props?.inventory?.minimumCancellationDays || 0);

  const editAccountType = (accountType) => {
    props.editAccountType(accountType);
  };

  const [isNew, setIsNew] = useState(!!!props.inventory?.guid);

  useEffect(() => {
    getInventoryTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventoryTypes(result);
      }
    });
    getAccountTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setAccountTypes(result);
        if (isNew) {
          setAccountType(result[0]);
        }
      }
    });
  }, [props.show]);

  useEffect(() => {
    if (!accountType?.familyPass) {
      setLockedAccount(false);
      setValue('lockedAccount', false);
    }
  }, [accountType])

  useEffect(() => {
    setTypesReady(inventoryTypes?.length && accountTypes?.length);
  }, [inventoryTypes, accountTypes]);

  useEffect(() => {
    setInventory(props?.inventory);
  }, [props?.inventory]);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(props?.inventory)
  });

  useEffect(() => {
    setValue('lockedAccount', !!props?.inventory?.lockedAccount);
    setLockedAccount(!!props?.inventory?.lockedAccount);
  }, [props?.inventory?.lockedAccount, setValue])

  useEffect(() => {
    setValue('minimumMembership', !!props?.inventory?.minimumMembership);
    setLockedAccount(!!props?.inventory?.minimumMembership);
  }, [props?.inventory?.minimumMembership, setValue])

  const handleClose = () => {
    props.handleClose();
  };

  const handleSave = (data) => {
    let d = {...data};
    d.inventoryImage = inventoryImage;
    d.inventoryImageName = inventoryImageName;
    d.inventoryImageType = inventoryImageType;
    d.inventoryMembership = true;
    d.accountType = accountType;
    d.minimumMembership = minimumMembership;
    d.minMembershipMonths = minMembershipMonths;
    d.minimumCancellation = minimumCancellation;
    d.minimumCancellationDays = minimumCancellationDays;
    props.handleSave(d);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setPreview(null);

      setInventoryImageName(null);
      setInventoryImageType(null);
      setInventoryImage(null);
      return;
    }
    setInventoryImageName(file.name);
    setInventoryImageType(file.type);

    const reader = new FileReader();

    reader.onload = function (evt) {
      setInventoryImage(btoa(evt.target.result));
    }
    reader.readAsBinaryString(file);
    setPreview(URL.createObjectURL(file))
  }
  const [recurOptions, setRecurOptions] = useState([
    {
      id: 0, value: 0
    },
    {
      id: 1, value: 1
    },
    {
      id: 2, value: 2
    },
    {
      id: 3, value: 3
    },
    {
      id: 4, value: 4
    },
    {
      id: 5, value: 5
    },
    {
      id: 6, value: 6
    },
    {
      id: 7, value: 7
    },
    {
      id: 8, value: 8
    },
    {
      id: 9, value: 9
    },
    {
      id: 10, value: 10
    },
    {
      id: 11, value: 11
    },
    {
      id: 12, value: 12
    }
  ]);

  return (
    <>
      <Modal onHide={handleClose} size={'lg'} show={props.show}>
        <form onSubmit={handleSubmit(handleSave)} id={'inventoryForm'}>
          <Modal.Header closeButton>
            <Modal.Title>{isNew ? 'Create New' : 'Manage'} Membership</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col className={'col col-main'} xs={12}>
                <Container>

                  <Row>
                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group">
                        <MDInput type="text" required
                                 disabled={inventory?.accountType?.siblingOptionsEnabled}
                                 {...register('name')}
                                 autoComplete="off"
                                 className="form-control" id="name"
                                 label="Membership Name"
                                 placeholder="Enter Membership Name"/>
                      </div>
                    </Col>
                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group">
                        <div className={'input-group'}>
                          <MDInput type="float" step="0.01" required
                                   defaultValue={inventory?.discountPrice}
                                   disabled={inventory?.accountType?.siblingOptionsEnabled}
                                   {...register(inventory?.accountType?.siblingOptionsEnabled ? 'discountPrice' : 'price', {
                                     valueAsNumber: true,
                                   })}
                                   InputLabelProps={{shrink: true}}
                                   InputProps={{
                                     startAdornment: <span className={'fa fa-dollar'}></span>
                                   }}
                                   defaultValue={'0.00'}
                                   autoComplete="off"
                                   className="form-control" id="price"
                                   label="Price"
                                   placeholder="Price"/>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className={'mt-2'}>

                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group native-margin-fix mt-1">
                        <label htmlFor="inventoryType" className={"native-label"}>Inventory Type</label>
                        {inventoryTypes?.length > 0 && <NativeSelect
                          variant="outlined"
                          disabled={inventory?.accountType?.siblingOptionsEnabled}
                          id={'inventoryType'} name={'inventoryType'} className={'form-control'}
                          {...register('inventoryType.id', {
                            valueAsNumber: true,
                          })} >
                          {
                            inventoryTypes.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>}
                      </div>
                      <div className="form-group mt-2">
                        <label htmlFor="accountType" className={"native-label"}>Account Type</label>
                        {accountTypes?.length > 0 && <NativeSelect
                          variant="outlined"
                          disabled={inventory?.accountType?.siblingOptionsEnabled}
                          id={'accountType'} name={'accountType'} className={'form-control'}
                          {...register('accountType.id', {
                            valueAsNumber: true,
                            onChange: (e) => {
                              for (let j in accountTypes) {
                                if (parseInt(e.target.value, 10) === accountTypes[j].id) {
                                  setAccountType(accountTypes[j]);
                                }
                              }
                            }
                          })} >
                          {
                            accountTypes.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name} {c.recurring ? ' (Recurring)' : ''} {c.familyPass ? ' (Family Pass)' : ''}
                              </option>)
                          }
                        </NativeSelect>}
                      </div>
                    </Col>


                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group native-margin-fix mt-1">
                        <label htmlFor="ageRange" className={"native-label"}>Status</label>
                        {statuses?.length && <NativeSelect
                          variant="outlined"
                          disabled={inventory?.accountType?.siblingOptionsEnabled}
                          required
                          id={'status'} name={'status'} className={'form-control'}
                          {...register('status.id', {
                            valueAsNumber: true
                          })} >
                          {
                            statuses?.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>}
                      </div>

                      <div className="form-group mt-3">
                        <label htmlFor="inventoryImage">Display Image</label>
                        <input type="file"
                               disabled={inventory?.accountType?.siblingOptionsEnabled}
                               accept="image/*"
                               {...register('inventoryImage', {
                                 onChange: (e) => {
                                   handleFileChange(e);
                                 }
                               })}
                               autoComplete="off"
                               className="form-control" id="inventoryImage"/>

                        {preview && <img className={'mt-2 img-thumbnail'} src={preview} alt="img"/>}
                        {!preview && inventory?.imageUrl &&
                          <img className={'mt-2 img-thumbnail'} src={inventory.imageUrl} alt="img"/>}
                      </div>
                    </Col>

                  </Row>

                  {accountType?.recurring && <>

                    <Row className={'mt-4'}>
                      <Col className={'col'} sm={6} xs={6}>
                        <label htmlFor="minimumMembership">
                          <Controller
                            name="minimumMembership"
                            control={control}
                            render={({field}) => (
                              <FormControlLabel
                                label={
                                  <span style={{
                                    fontWeight: 'normal'
                                  }}>Minimum Membership</span>
                                }
                                control={
                                  <Checkbox
                                    {...field}
                                    checked={field.value || false}
                                    onChange={(event, checked) => {
                                      field.onChange(checked);
                                      setMinimumMembership(checked);
                                    }}
                                  />}
                              />
                            )}
                          />
                        </label>
                      </Col>
                      <Col className={'col'} sm={6} xs={6}>
                        <label htmlFor={'minMembershipMonths'}>Minimum Contract Length</label>
                        <select
                          disabled={!minimumMembership}
                          {...register('minMembershipMonths', {
                            valueAsNumber: true,
                          })}
                          onChange={(e) => {
                            setMinMembershipMonths(parseInt(e.target.value, 10));
                          }}
                          id={'minMembershipMonths'} name={'minMembershipMonths'} className={'form-control'}>
                          {
                            recurOptions.map((c) =>
                              <option
                                value={c.id} key={c.id}>
                                {c.value} Months
                              </option>)
                          }
                        </select>
                      </Col>
                    </Row>

                    <Row>
                      <Col className={'col'} sm={12} xs={12}>
                        <p>
                          <small>
                            Use Minimum Membership Length to enforce contract length.
                            New Memberships created with cancellations will only be available in
                            portal when the initial contract length has passed.
                          </small>
                        </p>
                      </Col>
                    </Row>


                    <Row className={'mt-4'}>
                      <Col className={'col'} sm={6} xs={6}>
                        <label htmlFor="minimumCancellation">
                          <Controller
                            name="minimumCancellation"
                            control={control}
                            render={({field}) => (
                              <FormControlLabel
                                label={
                                  <span style={{
                                    fontWeight: 'normal'
                                  }}>Minimum Cancellation</span>
                                }
                                control={
                                  <Checkbox
                                    {...field}
                                    checked={field.value || false}
                                    onChange={(event, checked) => {
                                      field.onChange(checked);
                                      setMinimumCancellation(checked);
                                    }}
                                  />}
                              />
                            )}
                          />
                        </label>
                      </Col>
                      <Col className={'col'} sm={6} xs={6}>
                        <MDInput type="number" required={minimumCancellation}
                                 disabled={!minimumCancellation}
                                 {...register('minimumCancellationDays', {
                                   valueAsNumber: true,
                                   onChange: (e) => {
                                     setMinimumCancellationDays(parseInt(e.target.value, 10))
                                   },
                                   min: 1,
                                   max: 365
                                 })}
                                 InputLabelProps={{shrink: true}}
                                 autoComplete="off"
                                 className="form-control" id="minimumCancellationDays"
                                 label="Cancellation Days Notice"
                                 placeholder="Enter Minimum Cancellation Days"/>
                      </Col>
                    </Row>

                    <Row>
                      <Col className={'col'} sm={12} xs={12}>
                        <p>
                          <small>
                            Use <b>Minimum Cancellation Notice</b> to set how far in advance a member must request
                            cancellation. The membership will remain active and continue billing until the <b>end of the
                            billing period in which the notice period is satisfied</b>, then automatically cancel.
                          </small>
                        </p>
                      </Col>
                    </Row>

                  </>}


                  {accountType?.familyPass && <Row className={'mt-4'}>
                    <Col className={'col'} sm={12} xs={12}>
                      <label htmlFor="lockedAccount">
                        <Controller
                          name="lockedAccount"
                          control={control}
                          render={({field}) => (
                            <FormControlLabel
                              label={
                                <span style={{
                                  fontWeight: 'normal'
                                }}>Lock Membership</span>
                              }
                              control={
                                <Checkbox
                                  {...field}
                                  disabled={!accountType.familyPass}
                                  checked={field.value || false}
                                  onChange={(event, checked) => {
                                    field.onChange(checked);
                                    setLockedAccount(checked);
                                  }}
                                />}
                            />
                          )}
                        />
                      </label>
                    </Col>
                    <Col className={'col'} sm={12} xs={12}>
                      <p>
                        <small>
                          Locked Membership will require customer to assign membership to children and / or additional
                          family members at time of purchase.
                        </small>
                      </p>
                      <ul className={'list-group-horizontal'}>
                        <li className={'list-group-item-disc'}>
                          <small>When single use, membership is locked down a customer must choose their designated
                            child
                            for the membership</small>
                        </li>
                        <li className={'list-group-item-disc'}>
                          <small>Staff may modify a membership and update family / child associations</small>
                        </li>
                        <li className={'list-group-item-disc'}>
                          <small>When booking an event and using a family membership, only show memberships that are
                            assigned to the family member</small>
                        </li>
                      </ul>
                    </Col>
                  </Row>}

                  {lockedAccount && <>
                    {accountType?.familyPass && <>
                      <Row className={'mt-4'}>

                        <Col className={'col'} sm={12} xs={12}>
                          <h6>Family Options</h6>
                        </Col>

                        <Col className={'col'} sm={6} xs={6}>
                          <div className="form-group">
                            <MDInput type="number" required={lockedAccount}
                                     disabled={!accountType?.familyPass}
                                     {...register('numAdults', {
                                       valueAsNumber: true
                                     })}
                                     autoComplete="off"
                                     className="form-control" id="numAdults"
                                     label="Number Adults"
                                     placeholder="Enter Number of Adults"/>
                          </div>
                        </Col>

                        <Col className={'col'} sm={6} xs={6}>
                          <div className="form-group">
                            <MDInput type="number" required={lockedAccount}
                                     disabled={!accountType?.familyPass}
                                     {...register('numChildren', {
                                       valueAsNumber: true
                                     })}
                                     autoComplete="off"
                                     className="form-control" id="numChildren"
                                     label="Number Children"
                                     placeholder="Enter Number of Children"/>
                          </div>
                        </Col>
                        <Col className={'col'} sm={12} xs={12}>
                          <p>
                            <small>
                              When family pass, choose # of children, # of adults that a family membership can be
                              associated
                              with
                            </small></p>
                        </Col>

                      </Row>
                    </>}
                  </>}
                  <Row className={'mt-4'}>
                    <Col className={'col'} sm={12} xs={12}>
                      <div className="form-group native-margin-fix">
                        <label htmlFor="name" className={"native-label"}
                               disabled={inventory?.accountType?.siblingOptionsEnabled}
                        >Membership Description</label>
                        <TextareaAutosize
                          disabled={inventory?.accountType?.siblingOptionsEnabled}
                          {...register('desc')}
                          autoComplete="off"
                          maxLength={5000}
                          minRows={3}
                          className="form-control" id="desc"
                          placeholder={'Enter Membership Description'}/>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Row>

          </Modal.Body>
          <Modal.Footer>
            <MDButton type="submit" color="info" disabled={formInvalid || props.saving}>
              {props.saving ? 'Saving...' : 'Save'}
            </MDButton>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}